import { NavLink, Outlet } from 'react-router-dom';

// Wrapper for the "مجتمع مرسال" section — three internal tabs on top,
// each child renders its own body inside the Outlet:
//   - تقارير       → CommunityDashboardPage
//   - الشركاء      → CommunityPartnersPage
//   - النصوص التعريفية → CommunitySiteConfigPage
export default function CommunityWrapperPage() {
  const tab = (to: string, label: string) => (
    <NavLink to={to} end className={({ isActive }) => `home-tab ${isActive ? 'active' : ''}`}>
      {label}
    </NavLink>
  );

  return (
    <>
      <div className="home-tabs" role="tablist" aria-label="أقسام مجتمع مرسال">
        {tab('/community/reports', 'التقارير')}
        {tab('/community/partners', 'الشركاء')}
        {tab('/community/site-config', 'النصوص التعريفية')}
      </div>
      <div className="home-tab-panel">
        <Outlet />
      </div>
    </>
  );
}
